import { Icon } from '@iconify/react';

const BankAccountModal = ({
    show,
    handleClose,
    handleSubmit,
    formData,
    setFormData,
    editId,
    loading
}) => {
    if (!show) return null;

    return (
        <div className="modal-backdrop-custom" onClick={handleClose}>
            <style>{`
                .modal-backdrop-custom {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.5); z-index: 1050;
                    display: flex; align-items: center; justify-content: center;
                    padding: 20px;
                }
                .bank-modal {
                    background: #fff; border-radius: 12px; width: 100%; max-width: 560px;
                    box-shadow: 0 20px 60px rgba(0,0,0,0.15);
                    max-height: 90vh; overflow-y: auto;
                }
                .bank-modal-header {
                    padding: 10px 16px; border-bottom: 1px solid #e5e7eb;
                    display: flex; align-items: center; justify-content: space-between;
                }
                .bank-modal-body { padding: 12px 16px; }
                .bank-modal-footer {
                    padding: 8px 16px; border-top: 1px solid #e5e7eb;
                    display: flex; justify-content: flex-end; gap: 6px;
                }
                .bank-form-group { margin-bottom: 10px; }
                .bank-form-label {
                    display: block; font-size: 11px; font-weight: 500;
                    color: #374151; margin-bottom: 3px;
                }
                .bank-form-input {
                    width: 100%; padding: 6px 10px; border: 1px solid #d1d5db;
                    border-radius: 6px; font-size: 12px; transition: border-color 0.2s;
                    outline: none;
                }
                .bank-form-input:focus { border-color: #f59e0b; box-shadow: 0 0 0 3px rgba(245,158,11,0.1); }
                .bank-btn {
                    padding: 6px 14px; border-radius: 6px;
                    font-size: 11px; font-weight: 500; cursor: pointer; border: none;
                }
                .bank-btn-cancel { background: #fff; border: 1px solid #d1d5db; color: #374151; }
                .bank-btn-cancel:hover { background: #f9fafb; }
                .bank-btn-submit { background: #f59e0b; color: #fff; }
                .bank-btn-submit:hover { background: #d97706; }
                .bank-btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
            `}</style>

            <div className="bank-modal" onClick={(e) => e.stopPropagation()}>
                <div className="bank-modal-header">
                    <h6 className="mb-0 fw-semibold d-flex align-items-center gap-2">
                        <Icon icon={editId ? "mdi:bank-transfer" : "mdi:bank-plus"} className="text-xl" style={{ color: '#f59e0b' }} />
                        {editId ? 'Edit Bank Account' : 'Add Bank Account'}
                    </h6>
                    <button onClick={handleClose} className="btn btn-sm p-0 border-0" style={{ lineHeight: 1 }}>
                        <Icon icon="mdi:close" className="text-xl text-secondary-light" />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="bank-modal-body">
                        {/* Account Category & Bank Name in row */}
                        <div className="row">
                            <div className="col-md-4">
                                <div className="bank-form-group">
                                    <label className="bank-form-label">Account Category *</label>
                                    <select
                                        className="bank-form-input"
                                        value={formData.account_category}
                                        onChange={(e) => setFormData({ ...formData, account_category: e.target.value })}
                                        required
                                    >
                                        <option value="SAVING">Saving</option>
                                        <option value="CURRENT">Current</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="bank-form-group">
                                    <label className="bank-form-label">Bank Name *</label>
                                    <input
                                        type="text"
                                        className="bank-form-input"
                                        value={formData.bank_name}
                                        onChange={(e) => setFormData({ ...formData, bank_name: e.target.value })}
                                        placeholder="e.g. HDFC BANK"
                                        required
                                        maxLength={150}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Branch Name */}
                        <div className="bank-form-group">
                            <label className="bank-form-label">Branch Name</label>
                            <input
                                type="text"
                                className="bank-form-input"
                                value={formData.branch_name}
                                onChange={(e) => setFormData({ ...formData, branch_name: e.target.value })}
                                placeholder="e.g. ANDHERI WEST"
                                maxLength={150}
                            />
                        </div>

                        {/* Account Number & IFSC in row */}
                        <div className="row">
                            <div className="col-md-7">
                                <div className="bank-form-group">
                                    <label className="bank-form-label">Account Number *</label>
                                    <input
                                        type="text"
                                        className="bank-form-input"
                                        value={formData.account_number}
                                        onChange={(e) => setFormData({ ...formData, account_number: e.target.value })}
                                        placeholder="e.g. 50100XXXXXXX"
                                        minLength={4}
                                        maxLength={50}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-5">
                                <div className="bank-form-group">
                                    <label className="bank-form-label">IFSC Code *</label>
                                    <input
                                        type="text"
                                        className="bank-form-input"
                                        value={formData.ifsc_code}
                                        onChange={(e) => setFormData({ ...formData, ifsc_code: e.target.value.toUpperCase() })}
                                        placeholder="e.g. HDFC0001234"
                                        pattern="[A-Za-z]{4}0[A-Za-z0-9]{6}"
                                        title="Format: 4 letters + 0 + 6 alphanumeric (e.g. HDFC0001234)"
                                        maxLength={11}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Account Holder Name */}
                        <div className="bank-form-group">
                            <label className="bank-form-label">Account Holder Name</label>
                            <input
                                type="text"
                                className="bank-form-input"
                                value={formData.account_holder_name}
                                onChange={(e) => setFormData({ ...formData, account_holder_name: e.target.value })}
                                placeholder="e.g. ABC CO-OP HSG SOCIETY"
                                maxLength={200}
                            />
                        </div>

                        {/* Default Bank Toggle */}
                        <div className="bank-form-group">
                            <div className="d-flex align-items-center gap-3 p-12 radius-8" style={{ backgroundColor: '#fefce8', border: '1px solid #fde68a' }}>
                                <div className="form-check form-switch mb-0">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="isDefaultBank"
                                        checked={formData.is_default === 1}
                                        onChange={(e) => setFormData({ ...formData, is_default: e.target.checked ? 1 : 0 })}
                                    />
                                    <label className="form-check-label text-sm fw-medium" htmlFor="isDefaultBank">
                                        Set as Default Bank
                                    </label>
                                </div>
                                <span className="text-xs text-secondary-light">
                                    Used for CHEQUE, NEFT, UPI receipts
                                </span>
                            </div>
                        </div>

                        {/* GL Code Info */}
                        <div className="d-flex align-items-start gap-2 p-12 radius-8 bg-primary-50">
                            <Icon icon="mdi:information-outline" className="text-primary-600 text-lg flex-shrink-0 mt-1" />
                            <span className="text-xs text-secondary-light">
                                GL code will be auto-generated under <strong>01-01-02 BANK BALANCES</strong> group. The GL account name will be set to <strong>{formData.bank_name || 'BANK NAME'}{formData.account_number ? ` - ${formData.account_number}` : ''}</strong>.
                            </span>
                        </div>
                    </div>

                    <div className="bank-modal-footer">
                        <button type="button" className="bank-btn bank-btn-cancel" onClick={handleClose}>Cancel</button>
                        <button type="submit" className="bank-btn bank-btn-submit" disabled={loading}>
                            {loading ? (
                                <span className="d-flex align-items-center gap-2">
                                    <span className="spinner-border spinner-border-sm" />
                                    {editId ? 'Updating...' : 'Creating...'}
                                </span>
                            ) : (
                                editId ? 'Update Account' : 'Create Account'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BankAccountModal;
